import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { icons } from '@assets/icons';
import { getFormattedNumber } from '../group-table';
import ETypo from '@pages/DesignSystem/Typo';
import { callCleverTapEvent } from '@helpers';
import { CLEVER_TAP_EVENTS_CONSTANTS } from '@constants/cleverTap';
import actions from '../../invoiceDetailAction';
import { SITEMAP } from 'src/routes/sitemap';
import ImageComponent from '@sharedComponent/image-component';
import { INVOICE_LEFT_INFO_SECTION } from '@pages/invoice-details/constants';
import './invoiceLeftSection.scss';

export default function InvoiceLeftSection({ invoiceInfo, getInvoiceInfoLoading, invoiceStatementDownloadLoading }) {
	const dispatch = useDispatch();

	function downloadStatementOfAccounts() {
		callCleverTapEvent(CLEVER_TAP_EVENTS_CONSTANTS.invoice.invoice_soa);
		dispatch(actions.creators.downloadCompanyStatementStart());
	}
	return (
		<section className="invoice_left_section" data-testid="test-invoice-left-section">
			<div className="pending_invoice_amount_container">
				<span className="pending_invoice_amount_loader">
					{getInvoiceInfoLoading ? (
						<div className={`loader secondary_loader`} />
					) : (
						<ImageComponent src={icons.focus_state.InvoiceMoney} alt="mony-icon" />
					)}
				</span>

				{invoiceInfo?.isGroup ? (
					<>
						<small style={{ paddingTop: '8px', color: '#737780', fontSize: '12px', fontWeight: 700 }}>Pending Amount for Company</small>
						<ETypo bold h2 style={{ padding: '8px 0 16px' }}>
							AED {invoiceInfo?.pendingInvoiceAmount ? getFormattedNumber(invoiceInfo?.pendingInvoiceAmount) : '0.00'}
						</ETypo>
						<small style={{ paddingTop: '8px', color: '#737780', fontSize: '12px', fontWeight: 700 }}>Pending Amount for Group</small>
						<ETypo bold h2 style={{ padding: '8px 0 8px' }}>
							AED {invoiceInfo?.pendingInvoiceAmountForGroup ? getFormattedNumber(invoiceInfo?.pendingInvoiceAmountForGroup) : '0.00'}
						</ETypo>
					</>
				) : (
					<>
						<small style={{ paddingTop: '8px', color: '#737780', fontSize: '12px', fontWeight: 700 }}>Pending Invoice Amount</small>
						<ETypo bold h2 style={{ display: 'flex', alignItems: 'center' }}>
							AED{' '}
							{getInvoiceInfoLoading ? (
								<div style={{ marginLeft: '5px', height: '14px', width: '14px' }} className={`loader secondary_loader`} />
							) : invoiceInfo?.pendingInvoiceAmount ? (
								getFormattedNumber(invoiceInfo?.pendingInvoiceAmount)
							) : (
								'0.00'
							)}
						</ETypo>
					</>
				)}
			</div>
			<div className="invoice_options_container" data-testid="test-invoice-options">
				<Link to={SITEMAP.invoice.viewAll} className="invoice-btn">
					<span className="icon-container">
						<ImageComponent src={icons.focus_state.InvoiceFile} alt="view-all-invoices" />
					</span>
					<ETypo medium b2 color="#484B52" style={{ width: 'calc(100% - 48px)', padding: '0 8px' }}>
						{INVOICE_LEFT_INFO_SECTION.viewAllInvoices}
					</ETypo>
					<span style={{ width: '16px', height: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<ImageComponent src={icons.focus_state.InvoiceRightArrow} alt="view-all-invoices-arrow" />
					</span>
				</Link>
				<div className={`invoice-btn ${getInvoiceInfoLoading ? 'inactive' : ''}`} onClick={downloadStatementOfAccounts}>
					<span className="icon-container">
						{invoiceStatementDownloadLoading ? (
							<div className={`loader secondary_loader`} />
						) : (
							<ImageComponent src={icons.focus_state.InvoiceDownloadArrow} alt="statement-download" />
						)}
					</span>
					<ETypo medium b2 color="#484B52" style={{ width: 'calc(100% - 56px)', paddingLeft: '8px' }}>
						{INVOICE_LEFT_INFO_SECTION.statementOfAccounts}
					</ETypo>
				</div>
				<Link to={SITEMAP.invoice.history} className="invoice-btn">
					<span className="icon-container">
						<ImageComponent src={icons.focus_state.InvoicePaymentHistory} alt="payment-history" />
					</span>
					<ETypo medium b2 color="#484B52" style={{ width: 'calc(100% - 48px)', padding: '0 8px' }}>
						{INVOICE_LEFT_INFO_SECTION.paymentHistory}
					</ETypo>
					<span style={{ width: '16px', height: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<ImageComponent src={icons.focus_state.InvoiceRightArrow} alt="payment-history-arrow" />
					</span>
				</Link>
			</div>
		</section>
	);
}
